import { Card, Space } from '@sravni/react-design-system';
import type {
  SpaceAlign,
  SpaceDirection,
} from '@sravni/react-design-system/dist/types/components/Space/types/Space.types';
import { useIsMobile } from '@sravni/react-utils';
import type { FC } from 'react';
import React from 'react';

type IAuthenticationESIAButton = {
  button: JSX.Element;
  isButtonRight?: boolean;
  className?: string;
  title?: JSX.Element;
  subtitle?: JSX.Element;
  icon?: JSX.Element;
  gap?: 12 | 16;
  onClick?: () => void;
};

export const AuthenticationEsiaGrid: FC<IAuthenticationESIAButton> = ({
  subtitle,
  title,
  button,
  className,
  icon,
  isButtonRight,
  gap = 16,
  onClick,
}) => {
  const isMobile = useIsMobile();
  let direction: SpaceDirection = isMobile ? 'vertical' : 'horizontal';
  let align: SpaceAlign = isMobile ? 'start' : 'center';
  if (isButtonRight) {
    direction = 'horizontal';
    align = 'center';
  }

  return (
    <Card
      size={16}
      color="blue"
      className={className}
      onClick={onClick}
    >
      <Space
        size={gap}
        align={align}
        direction={direction}
      >
        <Space
          size={gap}
          align="center"
        >
          {icon}

          <Space direction="vertical">
            {title}
            {subtitle}
          </Space>
        </Space>

        {button}
      </Space>
    </Card>
  );
};
